jQuery(document).ready(function ($) {
    //
    // Read More Text reveal
    //
    $('.show_the_hidden_text').click(function () {
        $(this).siblings('.the_hidden_text').slideDown();
        $(this).slideUp();
    });
});
